export const contactsData = {
  email: "calher99@gmail.com",
  phone: "+61 (0) 437057403",
  address: "Sydney, Australia",
  github: "https://github.com/calher99",
  facebook: "https://www.facebook.com/carlos.alonsohernando",
  linkedIn: "https://www.linkedin.com/in/carlos-alonso-hernando-3a0242114/",
  // twitter: '',
  // medium: '',
  // stackOverflow: '',
  devUsername: "calher99",
};

